import type { FaireProductEntity } from "../../entity_types/product";

export const p_r8wsffxqtn: FaireProductEntity = {
  token: "p_r8wsffxqtn",
  type: "product",
  name: "thank you card",
  brandToken: "b_80vt7ytsru",
  brandName: "gentle thrills",
  imageUrl:
    "https://cdn.faire.com/fastly/eb1557fb30a0338a5c2b9be5742b4fb7f87c0f7ca4a89880e8f832df12821eb7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/76b3d825642063b112fd665b5e62875e01ecf8f27cbc87e8ee6bfa3956c80c1a.jpeg",
  ],
  priceDollars: 3.48,
  description:
    "the 2 most important words in the english language (in our opinion)\n\nthis greeting card is printed on thick, uncoated paper for satisfying writing and is blank inside. card comes bagged in a clear sleeve with a zany, striped envelope that includes space to write an address.\n\ncard measures 5” x 6.5”\n",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:59.129Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
